import React from 'react';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

import { getImageSrc } from "~/utils/cloudinary";
import { HeroSubheadline, Subheadline } from "~/components/typography";
import { Recycle, Fsc } from "~/components/icons";

import {
  QualityWrapper,
  QualityImage,
} from "./quality.style";

import {
  PdpInfoTitle,
  PdpInfoBlock,
  PdpInfoItem,
  PdpInfoIcon,
  PdpInfoLabel,
} from "./../pdp.style";

export const PdpQuality = () => {
  const imagePath = getImageSrc("premium-paper-square_gac3d1", "w_600,dpr_2");
  const gscIconPath = getImageSrc("icons/green-seal-certified_jwyzth", "w_24,dpr_2");

  return (
    <QualityWrapper>
      <PdpInfoBlock>
        <PdpInfoTitle>
          <HeroSubheadline color="primary">
            Premium Printing.
          </HeroSubheadline>
          <Subheadline color="primary">
            For both you and the planet.
          </Subheadline>
        </PdpInfoTitle>
        <PdpInfoItem>
          <PdpInfoIcon><Recycle /></PdpInfoIcon>
          <PdpInfoLabel>Recycled with 100% post-consumer fiber.</PdpInfoLabel>
        </PdpInfoItem>
        <PdpInfoItem>
          <PdpInfoIcon src={gscIconPath} />
          <PdpInfoLabel>Green Seal Certified, made with a minimum of 30% post consumer waste and meets federal procurement guidelines.</PdpInfoLabel>
        </PdpInfoItem>
        <PdpInfoItem>
          <PdpInfoIcon><Fsc /></PdpInfoIcon>
          <PdpInfoLabel>FSC® Certified, ensuring all conservation® papers meet the mark of responsible forestry.</PdpInfoLabel>
        </PdpInfoItem>
        <PdpInfoItem>
          <PdpInfoIcon><DoNotDisturbIcon /></PdpInfoIcon>
          <PdpInfoLabel>Manufactured Process Chlorine Free (PCF).</PdpInfoLabel>
        </PdpInfoItem>
      </PdpInfoBlock>
      <QualityImage src={imagePath} />
    </QualityWrapper>
  );
}
